import React, { useState, useEffect, useRef } from "react";
import "../styles/Control.css";
import { useGlobal } from "../context/ContenedorGlobal";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from "chart.js";
import { useApiFetch } from "../utils/apiFetch";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function Control() {
    const { identidad, logout } = useGlobal();
    const [indicadores, setIndicadores] = useState([]);
    const [mensaje, setMensaje] = useState("");
    const [loading, setLoading] = useState(true);
    const apiFetch = useApiFetch();
    const chartRef = useRef(null);

    useEffect(() => {
        if (!identidad) {
            setMensaje("Debes iniciar sesión para ver el panel de control.");
            setLoading(false);
            return;
        }

        const cargarIndicadores = async () => {
            try {
                const data = await apiFetch("control.php", { method: "GET" }, logout);

                if (data.status === "success") {
                    setIndicadores(data.data || []);
                } else {
                    setMensaje(data.message || "Error al cargar indicadores.");
                }
            } catch {
                setMensaje("Error de conexión con la API.");
            } finally {
                setLoading(false);
            }
        };

        cargarIndicadores();
    }, [identidad]);

    const exportarPDF = () => {
        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Reporte de Indicadores de Control", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla
        autoTable(doc, {
            startY: 50,
            head: [["Indicador", "Valor"]],
            body: indicadores.map(i => [i.indicador, i.valor])
        });

        // Gráfica
        if (chartRef.current) {
            const chartInstance = chartRef.current;
            const imgData = chartInstance.toBase64Image();
            doc.addImage(imgData, "PNG", 15, doc.lastAutoTable.finalY + 20, 120, 70);
        }

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2025-2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save("control.pdf");
    };

    const exportarCSV = () => {
        const filas = [["Indicador", "Valor"], ...indicadores.map(i => [i.indicador, i.valor])];

        const csvContent = filas.map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "control.csv");
        link.click();
    };

    if (loading) return <p>Cargando indicadores...</p>;
    if (mensaje) return <p className="error">{mensaje}</p>;

    return (
        <div className="control-contenedor">
            {/* Columna izquierda: tabla */}
            <div className="control-tabla">
                <h2>Indicador Global</h2>
                <table className="tabla-estandar">
                    <thead>
                        <tr>
                            <th>Indicador</th>
                            <th>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {indicadores.map((item, index) => (
                            <tr key={index}>
                                <td data-label="Indicador">{item.indicador}</td>
                                <td data-label="Valor">{item.valor}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <button onClick={exportarCSV}>Exportar<br></br>en CSV</button>
            </div>

            {/* Columna derecha: gráfica */}
            <div className="control-grafica">
                <h2>Eficiencia Operativa</h2>
                {indicadores.length > 0 && (
                    <Bar
                        ref={chartRef}
                        data={{
                            labels: ["Eficiencia Operativa"],
                            datasets: [
                                {
                                    label: "% de eficiencia",
                                    data: [
                                        Number(
                                            indicadores.find(
                                                i => i.indicador === "Eficiencia operativa"
                                            )?.valor || 0
                                        )
                                    ],
                                    backgroundColor: "rgba(101, 29, 50, 0.7)"
                                }
                            ]
                        }}
                        options={{
                            responsive: true,
                            plugins: {
                                legend: { display: false },
                                title: { display: true, text: "Indicador de eficiencia (%)" }
                            },
                            scales: {
                                y: { beginAtZero: true, max: 100 }
                            }
                        }}
                    />
                )}
                <button onClick={exportarPDF}>Exportar<br></br>en PDF</button>
            </div>
        </div>
    );
}

export default Control;